import { stringBuilder } from "@spordle/helpers";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import UserImg from "../../UserImg";
import PropTypes from 'prop-types';

/**
 * Photo to display primary meta member's photo of the account
 * @param {Object} props
 * @param {string} [props.className]
 * @param {number|string} [props.width=40]
 * @param {number|string} [props.height=props.width]
 * @returns {JSX.Element}
 */
const MainPhoto = ({ className, width = 30, height }) => {
    const { userData, getPrimaryMeta } = useContext(AuthContext);
    const [ primary, setPrimary ] = useState(null);

    useEffect(() => {
        getPrimaryMeta()
            .then(setPrimary)
            .catch(console.error);
    }, []);

    return (
        userData ?
            <UserImg
                className={stringBuilder('p-0', className)}
                width={width}
                height={width || height}
                src={primary?.attachment?.full_path || userData.attributes?.logo}
                alt={userData.attributes?.name + ' ' + userData.attributes?.family_name}
                abbr={userData.attributes?.name?.charAt(0) + userData.attributes?.family_name?.charAt(0)}
                filePos={primary?.attachment?.file_position}
            />
            :
            <div
                className={stringBuilder('bg-light rounded-circle', className)}
                style={{
                    width: width,
                    height: height,
                }}
            />
    )
}

export default MainPhoto;

MainPhoto.propTypes = {
    className: PropTypes.string,
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

MainPhoto.defaultProps = {
    width: 40,
    height: 40,
};